import { useEffect } from "react";
import { useAlert } from "hooks/useAlert";
import { useHistory } from "react-router-dom";

export const useSubmitStatus = (
    { isSubmitted, message, redirectTo }: { isSubmitted: boolean; message: string; redirectTo?: string },
    onSubmitCb?: () => void
) => {
    const { toggleAlert } = useAlert();
    const { push } = useHistory();

    useEffect(() => {
        if (isSubmitted) {
            toggleAlert({ message, type: "success" });

            if (redirectTo) {
                push(redirectTo);
            }

            onSubmitCb?.();
        }
        // eslint-disable-next-line
    }, [isSubmitted, message, toggleAlert, redirectTo, push]);
};
